module.exports = __webpack_public_path__ + "img/mp2.cd34d6f6.png";